import { useState } from "react";
import { useDispatch } from "react-redux";
import useWebsiteConfiguration from "../../../hooks/websiteConfigurations/useWebsiteConfiguration";
import { websiteConfigurationEnum } from "../../../enums/websiteConfigurations/websiteConfiguration.enum";
import AlertService from "../../../services/alerts/alert.service";
import websiteConfigurationActions from "../../../store/actions/websiteConfigurations/websiteConfiguration.actions";
import TableElementComponent from "../../elements/TableElementComponent";
import { fileTypesEnum } from "../../../enums/fileTypes.enum";
import FileInputElementComponent from "../../elements/inputElements/FileInputElementComponent";

export const WebsiteConfigurationHomeBannerSection = () => {
  const dispatch = useDispatch();
  const [currentValue, setCurrentValue] = useState(null);

  const { configurationValue: banners, refetch } = useWebsiteConfiguration(websiteConfigurationEnum.HomeBanner);
  const bannerList = Array.isArray(banners) ? banners : [];

  const handleFileChange = (file, fileDetails) => {
    setCurrentValue({ file, Url: fileDetails.url });
  };

  const handleUploadImage = async () => {
    if (!currentValue?.file) {
      AlertService.warning("בחירת קובץ", "אנא בחר תמונה להעלאה.");
      return;
    }
    try {
      const formData = new FormData();
      formData.append("file", currentValue.file);
      const response = await dispatch(websiteConfigurationActions.uploadImage("HomePageBanners", formData));
      console.log("🚀 ~ handleUploadImage ~ response:", response)
      AlertService.success("העלאה הצליחה", "התמונה נוספה בהצלחה.");
      refetch();
      setCurrentValue(null);
    } catch (error) {
      AlertService.error("שגיאה", "אירעה שגיאה בהעלאת התמונה.");
    }
  };

  const handleDeleteImage = async (bannerId) => {
    const isConfirmed = await AlertService.confirm("מחיקת תמונה", "האם אתה בטוח שברצונך למחוק את התמונה?", "כן, מחק", "ביטול");
    if (!isConfirmed) return;
    try {
      await dispatch(websiteConfigurationActions.deleteHomeBanner(bannerId));
      AlertService.success("נמחק בהצלחה", "התמונה נמחקה.");
      refetch();
    } catch {
      AlertService.error("שגיאה", "לא ניתן למחוק את התמונה.");
    }
  };

  const getExistingBannersTable = () => {
    if (!bannerList || bannerList.length === 0) return null;

    const columns = [
      {
        label: "תמונה",
        field: "Url",
        render: (value) => (
          <div className="imageColumnContainer">
            <img src={value} alt="banner" />
          </div>
        ),
      },
    ];

    const actions = [
      {
        label: "מחק",
        icon: "fa-solid fa-trash",
        className: "redButton",
        onClick: (item) => handleDeleteImage(item.Id),
      },
    ];

    return <TableElementComponent columns={columns} data={bannerList} actions={actions} />;
  };

  const getFileInputElement = () => {
    const inputProps = {
      label: "תמונת באנר חדשה",
      name: "bannerImage",
      value: currentValue?.Url,
      fileType: fileTypesEnum.image,
      onChange: handleFileChange,
    };
    return <FileInputElementComponent props={inputProps} />;
  };

  return (
    <div className="websiteConfigurationHomeBannerSection">
      {getExistingBannersTable()}
      <div className="uploadNewBannerContainer">
        {getFileInputElement()}
        <button className="primaryButton" onClick={handleUploadImage}>
          העלה באנר
        </button>
      </div>
    </div>
  );
};

export default WebsiteConfigurationHomeBannerSection;
